import { Component, OnInit, ViewChild, Output, EventEmitter, Input } from '@angular/core';
import {Router, ActivatedRoute } from "@angular/router";
import { ContentAuthoringService } from "../../services/content-authoring.service";
import { NgxSpinnerService } from "ngx-spinner";
interface objectEmit {
  capsuleData_id: any,
  status: boolean
}
@Component({
  selector: 'app-view-capsule',
  templateUrl: './view-capsule.component.html',
  styleUrls: ['./view-capsule.component.scss']
})
export class ViewCapsuleComponent implements OnInit {
  @Output() finalViewCap: any = new EventEmitter();
  @Input() capsuleData: any;

  adminData:any;tab:any;
  errorInfo:{isError:boolean,errorMsg:string} = {isError:false,errorMsg:''}
  content_capsule_id :any;data={};contentDetailsData:any;contentDetailsDatas:any=[];
  returnObj: objectEmit = { capsuleData_id: null, status: false };
  constructor(private contentAuthoringApi:ContentAuthoringService,
    private route: ActivatedRoute,
    private router: Router,
    private spinner: NgxSpinnerService) { }

    ngOnInit(): void {
      this.spinner.show();
      if (this.capsuleData != null && this.capsuleData != '') {
        this.getContentAuthDetails(this.capsuleData);
      }
      this.adminData=JSON.parse(localStorage.getItem('adminData') || '[]');
    }
     /***back page **/
    onBackToAuthCr() {
      // this.returnObj.capsuleData_id = this.capsuleData;
      // this.returnObj.status = true;
      this.finalViewCap.emit(this.returnObj);
    }
    getContentAuthDetails(content_capsule_id:any){
      this.spinner.show();
      this.contentAuthoringApi.getContentAuthDetails(content_capsule_id).subscribe(
        (data)=>{
        if(data.success){
          this.spinner.hide();
          this.contentDetailsData=data.data;
          this.contentDetailsDatas=data.data.contentCapsuleMedia;  
          //console.log('conent',this.contentDetailsData);
        }else{
          this.spinner.hide();
          this.errorInfo.isError = true;
          this.errorInfo.errorMsg = 'No data Exist'
        }
        },
        (error) => {
          this.spinner.hide();
          this.errorInfo.errorMsg = error;
         },
      );
    }
    getMediaType(mediatypeArr:any,media_type:any){
      const checkMediType = (obj: { media_type: string; }) => obj.media_type == media_type;
      return mediatypeArr.some(checkMediType);
    }
    logout(){
      //localStorage.clear();
      localStorage.removeItem('adminLoginPass');
 localStorage.removeItem('adminData');
      this.router.navigate(['./admin-login']);
     } 

}
